const sizes = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ИБ'];

/** Размер файла: «0 Б», «1.5 КБ», «2 МБ» — до `decimals` знаков после точки, нули в конце отброшены. */
export const formatBytes = (bytes: number, decimals = 2) => {
    if (!+bytes) return '0 Б';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
